import React, { useContext } from 'react';
import s from './PlanFaq.scss';
import { AccordionContext } from './AccordionWrapper';

const AccordionItem = props => {
  const { active, setActive } = useContext(AccordionContext);

  const eventHandler = (e, index) => {
    e.preventDefault();
    if (active === index) {
      setActive(-1);
    } else {
      setActive(index);
    }
  };

  return (
    <li
      onClick={e => eventHandler(e, props.index)}
      className={
        active === props.index
          ? `${s.accordion} ${s.collapsed}`
          : `${s.accordion}`
      }
    >
      <div className={s.que_head}>{props.title}</div>
      {active === props.index && (
        <div
          className={s.ans_desc}
          dangerouslySetInnerHTML={{
            __html: unescape(props.content),
          }}
        />
      )}
      {/* <div
        id={`sect-${  indexCount(props.index)}`}
        className={active === props.index ? 'panel-open' : 'panel-close'}
      >
        {props.content}
      </div> */}
    </li>
  );
};

export default AccordionItem;
